module.exports = __webpack_public_path__ + "img/w-word-of-mouth.fed86f14.svg";